import React from "react";
import { useState } from "react";
import { doc, updateDoc } from "firebase/firestore";
import { db } from "../../firebase";
import { useToast } from "../../components/ui/ToastProvider";
import { mapFirebaseError } from "../../utils/userErrors";

const MARKETPLACE_TEMPLATES = [
  {
    id: "starter-morning",
    name: "Morning Starter Pack",
    chores: [
      { title: "Make bed", points: 3, frequency: "repeat", repeatType: "daily" },
      { title: "Brush teeth", points: 2, frequency: "repeat", repeatType: "daily" }
    ]
  },
  {
    id: "after-school",
    name: "After School Flow",
    chores: [
      { title: "Snack cleanup", points: 2, frequency: "repeat", repeatType: "weekdays" },
      { title: "Homework", points: 6, frequency: "repeat", repeatType: "weekdays" }
    ]
  }
];

export default function MarketplaceCard({ familyId, familySettings, canManage }) {
  const { showToast } = useToast();
  const [installingId, setInstallingId] = useState("");
  const [errorText, setErrorText] = useState("");
  const templates = familySettings?.taskTemplates || [];

  const installTemplate = async (template) => {
    if (!canManage) return;
    const exists = templates.some(t => t.id === template.id);
    if (exists) return;
    setErrorText("");
    setInstallingId(template.id);
    const nextTemplates = [...templates, { id: template.id, name: template.name, chores: template.chores }];
    try {
      await updateDoc(doc(db, "families", familyId), { taskTemplates: nextTemplates });
      showToast({ type: "success", message: `${template.name} installed.` });
    } catch (error) {
      setErrorText(mapFirebaseError(error, "Unable to install template."));
    } finally {
      setInstallingId("");
    }
  };

  return (
    <div className="glass parent-card">
      <div className="header-flex">
        <h2>Template Marketplace</h2>
      </div>
      <div className="card-body">
        {!canManage && (
          <p style={{ textAlign: "center", opacity: 0.6 }}>You have view-only access.</p>
        )}
        {errorText && (
          <small className="pin-error" role="alert">
            {errorText}
          </small>
        )}
        {canManage &&
          MARKETPLACE_TEMPLATES.map(template => {
            const installed = templates.some(t => t.id === template.id);
            return (
              <div key={template.id} className="parent-list-item" style={{ gap: "8px" }}>
                <div style={{ display: "flex", flexDirection: "column" }}>
                  <strong>{template.name}</strong>
                  <small style={{ opacity: 0.7 }}>{template.chores.length} chores</small>
                </div>
                <button
                  className="btn-nav"
                  disabled={installed || installingId === template.id}
                  onClick={() => installTemplate(template)}
                >
                  {installed ? "Installed" : installingId === template.id ? "Installing..." : "Install"}
                </button>
              </div>
            );
          })}
      </div>
    </div>
  );
}
